export interface DiscountCountdown {
    days?: number;
    hours?: number;
    minutes?: number;
    seconds?: number;
    difference: number;
}

export function parseDiscountTimestamp(value: unknown): number | null {
    const timestamp =
        value instanceof Date
            ? value.getTime()
            : typeof value === 'string' && value.trim()
            ? new Date(value).getTime()
            : NaN;
    return Number.isFinite(timestamp) ? timestamp : null;
}

export function getDiscountTimeLeft(
    target: number,
    now: number
): DiscountCountdown {
    const difference = target - now;
    if (!Number.isFinite(difference) || difference <= 0)
        return { difference: 0 };
    return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
        difference,
    };
}
